import { ToxnotServiceClient } from "../store/ToxnotServiceClient";

// ===============================================================================

export enum DataSourceOptionType {
    SelectSingle,
    SelectMultiple,
    Import,
    ImportSupplierData,
    ImportSummaryData,
    ImportHpdBuilder,
    ImportScipData,
    NeedSupplyChainData,
    EditExisting
}

// ===============================================================================

export default class TowStarter {
    public constructor() {

    }

    // ===============================================================================

    private async writeTaskToService(workflowType: string, towState: any) {
        const serviceClient = new ToxnotServiceClient();

        const towUpdateRequest = {
            taskId: null,
            workflowType: workflowType,
            jsonState: JSON.stringify(towState)
        }

        const updateResult = await serviceClient.towUpdate(towUpdateRequest);

        return updateResult.success;
    }

    // ===============================================================================

    public async startTow(
        towOption: DataSourceOptionType,
        workflowType: string,
        towStateGenerator: (inception: string, activeStep: string) => any,
        context?: string
    ) {
        let inception = "LibrarySelectSingle";
        let activeStep = "LibrarySingleSelect";

        switch (towOption) {
            case DataSourceOptionType.SelectSingle:
                inception = "LibrarySelectSingle";
                activeStep = "LibrarySingleSelect";
                break;
            case DataSourceOptionType.SelectMultiple:
                inception = "LibrarySelectMulti";
                activeStep = "LibraryMultiSelect";
                break;
            case DataSourceOptionType.Import:
                inception = "Import";
                activeStep = "SelectFileAndImportOptions";
                break;
            case DataSourceOptionType.ImportSummaryData:
            case DataSourceOptionType.ImportScipData:
                inception = "Import";
                activeStep = "SelectGenericSpreadsheetFile";
                break;
            case DataSourceOptionType.ImportSupplierData:
                inception = "Import";
                activeStep = "SelectSupplierDataSpreadsheetFile";
                break;
            case DataSourceOptionType.ImportHpdBuilder:
                inception = "Import";
                activeStep = "HpdBuilderLogin";
                break;
            case DataSourceOptionType.EditExisting:
                inception = "LibrarySelectSingle";
                activeStep = "ReviewBOM"; 
        }

        const towState = towStateGenerator(inception, activeStep);

        const success = await this.writeTaskToService(workflowType, towState);

        if (!success) {
            return false;
        }

        if (towOption === DataSourceOptionType.Import) {
            // import data
            window.location.href = "/Data/NewProduct";
        }
        else if ((towOption === DataSourceOptionType.ImportSummaryData) || (towOption === DataSourceOptionType.ImportScipData)) {
            // import data
            window.location.href = "/Data/Import";
        }
        else if (towOption === DataSourceOptionType.ImportSupplierData) {
            // import supplier data
            window.location.href = "/Suppliers/Import";
        }
        else if (towOption === DataSourceOptionType.ImportHpdBuilder) {
            window.location.href = "/Hpdc/ImportHpd";
        }
        else if (towOption === DataSourceOptionType.EditExisting) {
            if (!context) {
                throw new Error("tow options was edit existing, but no public inventory id was provided");
            }
            // Review Bom
            window.location.href = `/Data/Inventory?inventoryId=${context}&mode=PublishReview`;
        }
        else {
            // select from library first
            window.location.href = "/Data/Library";
        }

        return true;
    }

    // ===============================================================================

    public async startPublishSmWorkflow(option: DataSourceOptionType, sourceInventoryId?: string) {
        return await this.startTow(
            option,
            "PublishSM",
            (inception, activeStep) => ({
                inception: inception,
                activeStep: activeStep,
                importMode: "SingleMaterialSpreadsheet",
                singleResultInventoryId: sourceInventoryId ?? null,
                multiResultInventoryIds: null,
                importId: null,
                publicInventoryId: null,
                publicInventoryDataId: null,
                implementationInventoryId: null,
                sourceInventoryTargetVersionId: null,
                sharedMaterialId: null,
                context: null,
                previewStartId: null,
                previewStartContext: null,
                accessEmails: "",
                bulkOperationId: null,
                useStreamlinedGetStartedImportUi: true
            }),
            sourceInventoryId
        );
    }

    // ===============================================================================
}